import  React, { useState , useEffect } from 'react'
import "./datetime.css";

export const DateTime = (props) => {

    var [date,setDate] = useState(new Date());
    
    useEffect(() => {
        var timer = setInterval(()=>setDate(new Date()), 1000 )
        return function clear() {
            clearInterval(timer)
        }
    
    });

    return(
        <div className='datetime-container'>
            <p className={props.color + ' date'}>{date.toLocaleDateString()} <br ></br>Stockholm, {date.toLocaleTimeString()}</p>   
        </div>
    )
}

export default DateTime